/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconShouyeXuanzhong: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M56.8832 385.024v582.0928H967.168V385.9456L497.2544 56.832l-440.32 328.0896z m-19.456-64.6144L442.88 18.432a93.0816 93.0816 0 0 1 108.9536-1.5872l432.5376 302.7968c24.832 17.408 39.68 45.8752 39.68 76.288v534.9888A93.0816 93.0816 0 0 1 930.9184 1024H93.0816A93.0816 93.0816 0 0 1 0 930.9184V395.0592C0 365.568 13.8752 337.92 37.4784 320.4096z"
        fill={getIconColor(color, 0, '#FFFFFF')}
      />
      <path
        d="M513.2288 1010.176h1.28c31.0784 0 37.0688-23.7568 37.0688-53.0944v-212.7872c0-29.3376-5.9904-53.0944-37.0688-53.0944h-1.3312c-31.0272 0-38.4 23.7568-38.4 53.0944v212.7872c0.1024 29.3376 7.424 53.1456 38.4512 53.1456z"
        fill={getIconColor(color, 1, '#FFFFFF')}
      />
    </svg>
  );
};

IconShouyeXuanzhong.defaultProps = {
  size: 18,
};

export default IconShouyeXuanzhong;
